import React from "react";
import { IconContext } from "react-icons";
import { FaTshirt, FaStar, FaPalette } from "react-icons/fa";
import styles from "./style.module.scss";

export default function Accolades() {
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <span>
          <IconContext.Provider
            value={{ size: "2.5em", className: styles.icon }}
          >
            <FaStar />
          </IconContext.Provider>
          5/5 Rating on Google
        </span>
        <span>
          <IconContext.Provider
            value={{ size: "2.5em", className: styles.icon }}
          >
            <FaTshirt />
          </IconContext.Provider>
          6,000+ Tees Printed
        </span>
        <span>
          <IconContext.Provider
            value={{ size: "2.5em", className: styles.icon }}
          >
            <FaPalette />
          </IconContext.Provider>
          Hundreds of Designs
        </span>
      </div>
    </div>
  );
}
